<template>
  <div>
    <v-form ref="form">
      <v-dialog
        fullscreen
        value="true"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-app-bar flat class="card-toolbar-title">
            <v-toolbar-title>
              {{ editedItem.federationId ? 'Edit' : 'Add' }} Okta Federation
            </v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>

          <v-card-text>
            <v-text-field
              id="domain"
              v-model="editedItem.domain"
              :rules="required"
              class="required"
              label="Domain"
              name="domain"
            />
            <v-radio-group v-model="homeType" label="Logout Home Type">
              <v-radio label="Close" value="close" /> (After logging out, users are requested to close their tab or browser.)
              <v-radio label="URL" value="url" /> (Redirects to the specified URL after logging out. Make sure to contact Okta Support and ask them to add this URL to the "Logout redirect URIs".)
              <v-radio label="Default" value="blank" /> (Returns the user to their Okta homepage after logging out.)
            </v-radio-group>
            <v-text-field
              v-show="homeType == 'url'"
              id="logoutHome"
              v-model="editedItem.logoutHome"
              label="Logout Home"
              name="logoutHome"
            />
            <v-text-field
              id="changePassword"
              v-model="editedItem.changePassword"
              label="Change Password"
              name="changePassword"
            />
            <v-radio-group v-model="federationType" label="Federation Type">
              <v-radio label="Disabled" value="disabled" /> (Do not allow account creation with this domain, instead accounts are auto created from external  federations. Use this for Single-Sign-On accounts.)
              <v-radio label="Okta" value="okta" /> (Normal account creation, accounts are stored in Okta, and Okta manages passwords. This is ONLY needed in order to create automatic User Groups! If there is some other process that is creating accounts in Okta. Normally instead of picking this, just don't have the domain in the table at all.)
              <v-radio label="Manual" value="manual" /> (Normal account creation, but accounts, in particular the authentication, are federated using these parameters supplied by an Okta admin.)
            </v-radio-group>
            <v-text-field
              v-show="federationType == 'manual'"
              id="credentialProviderType"
              v-model="editedItem.credentialProviderType"
              label="Credential Provider Type"
              name="credentialProviderType"
            />
            <v-text-field
              v-show="federationType == 'manual'"
              id="credentialProviderName"
              v-model="editedItem.credentialProviderName"
              label="Credential Provider Name"
              name="credentialProviderName"
            />
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="primary" text @click.native="close">Cancel</v-btn>
              <v-btn color="primary" @click.native="save">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'federation-table-modal',
  props: {
    editedItem: Object
  },
  data() {
    return {
      federationType: this.editedItem.credentialProviderType ? (this.editedItem.credentialProviderName ? 'manual' : 'disabled') : 'okta',
      homeType: this.editedItem.logoutHome ? (this.editedItem.logoutHome === 'close' ? 'close' : 'url') : 'blank',
      required: [
        v => !!v || 'Required'
      ]
    }
  },
  methods: {
    ...mapActions('oktaFederations', ['addFederation', 'updateFederation']),
    save() {
      if (this.$refs.form.validate()) {
        switch (this.federationType) {
          case 'disabled':
            this.editedItem.credentialProviderType = this.editedItem.credentialProviderType ? this.editedItem.credentialProviderType : 'disabled'
            this.editedItem.credentialProviderName = ''
            break
          case 'okta':
            this.editedItem.credentialProviderType = ''
            this.editedItem.credentialProviderName = ''
            break
          case 'manual':
            break
        }
        switch (this.homeType) {
          case 'close':
            this.editedItem.logoutHome = 'close'
            break
          case 'blank':
            this.editedItem.logoutHome = ''
            break
          case 'url':
            break
        }
        this[this.editedItem.federationId ? 'updateFederation' : 'addFederation'](this.editedItem).then(this.close, () => {})
      }
    },
    close() {
      this.$emit('close')
    }

  }
}
</script>
